import { useState } from "react"
import {
  Container,
  Grid,
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
} from "@material-ui/core"
import HomePage from "../../Home"
import AccountBalanceIcon from "@material-ui/icons/AccountBalance"
import ReceiptIcon from "@material-ui/icons/Receipt"
import SearchIcon from '@material-ui/icons/Search'
import VPagoUnico from "../VPagoUnico"
import VBusquedaPagos from "../VBusquedaPagos"
import VPagosMasivos from "../VPagoMasivos"
import InfoTipoCambio from "../../../global/InfoTipoCambio"
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

export default function VPagos() {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <HomePage>
      <Container>
        <Grid item xs={12}>
          <h3>Pagos</h3>
        </Grid>
        <Grid item xs={12}>
          <InfoTipoCambio Banxico={true} />
        </Grid>
        <Grid item xs={12}>
          <AppBar position="static" color="secondary">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="on"
              indicatorColor="primary"
              aria-label="scrollable force tabs example"
            >
              <Tab
                label="Pago unico"
                icon={<ReceiptIcon />}
                {...a11yProps(0)}
              />
              <Tab
                label="Pagos masivos"
                icon={<AccountBalanceIcon />}
                {...a11yProps(1)}
              />
              <Tab
                label="Historial de pagos"
                icon={<SearchIcon />}
                {...a11yProps(2)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <VPagoUnico />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <VPagosMasivos />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <VBusquedaPagos />
          </TabPanel>
        </Grid>
      </Container>
    </HomePage>
  );
}
